/**
 * ZALES & REGO — Main JS
 * Gilda y Tomate · 2026
 */

(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── 1. PRE-HERO INSTANT REVEAL ────────────────────────────
  // If the gate is present, the pre-hero is hidden behind it
  // and IntersectionObserver will never fire on it.
  // Mark all pre-hero reveal elements as visible immediately
  // so they are fully painted and waiting behind the gate panels.
  var gate = document.getElementById('zr-gate');
  if (gate) {
    var prehero = document.getElementById('zr-prehero');
    if (prehero) {
      prehero.querySelectorAll('.zr-reveal, .zr-reveal--scale').forEach(function (el) {
        el.classList.add('zr-visible');
      });
    }
  }

  // ── 2. SCROLL REVEAL ──────────────────────────────────────
  if (!prefersReduced && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('zr-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    document.querySelectorAll('.zr-reveal, .zr-reveal--scale').forEach(function (el) {
      // Skip pre-hero elements — already handled above
      if (gate && el.closest('#zr-prehero')) return;
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.zr-reveal, .zr-reveal--scale').forEach(function (el) {
      el.classList.add('zr-visible');
    });
  }

  // ── 3. NAV BACKGROUND STATE ───────────────────────────────
  // Three states:
  //   (default)     — transparent, top of page
  //   .zr-scrolled  — semi-transparent gradient, scrolled a little
  //   .zr-opaque    — fully solid, past the hero (or forced on non-hero pages)
  //
  // Force-opaque pages additionally toggle .zr-nav--past-hero once
  // scrolled past THAT PAGE'S OWN hero/banner section, switching from
  // nav_bg_opaque to nav_bg_opaque_scrolled (see zr-nav.liquid). Hero
  // sections differ in class name per page type (Trade/Cofres/Contact
  // share .zr-th; La Casa uses its own .zr-lch; Collection pages use
  // .zr-coll-banner; the blog uses .zr-blog-hero) — check each in
  // turn, first match wins.
  var nav = document.getElementById('zr-nav');

  if (nav) {
    var forceOpaque = nav.getAttribute('data-force-opaque') === 'true';

    if (forceOpaque) {
      // .zr-opaque is now rendered server-side in zr-nav.liquid
      // (class="...{% if force_opaque %} zr-opaque{% endif %}"), so
      // it's present on first paint. Adding it here too used to mean
      // the class briefly went from absent -> present right after
      // load, animating the height/background transition every time
      // (the visible "nav dips then settles" bug).

      var heroSelectors = ['.zr-th', '.zr-lch', '.zr-coll-banner', '.zr-blog-hero'];
      var heroEl = null;
      for (var i = 0; i < heroSelectors.length; i++) {
        heroEl = document.querySelector(heroSelectors[i]);
        if (heroEl) break;
      }

      if (heroEl && 'IntersectionObserver' in window) {
        // Directly detects when the hero has actually left the
        // viewport, rather than computing its document position by
        // hand (which doesn't account for what else — breadcrumb bar,
        // margins, etc. — sits above it on a given page).
        var heroObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            nav.classList.toggle('zr-nav--past-hero', scrolledPast);
          });
        }, { threshold: 0 });
        heroObserver.observe(heroEl);
      }
    } else {
      var scrollThreshold = 60;
      var prehero = document.getElementById('zr-prehero');

      function updateNav() {
        var y = window.scrollY;
        var opaqueThreshold = prehero ? prehero.offsetHeight : Infinity;

        if (y >= opaqueThreshold) {
          nav.classList.add('zr-opaque');
          nav.classList.remove('zr-scrolled');
        } else if (y > scrollThreshold) {
          nav.classList.add('zr-scrolled');
          nav.classList.remove('zr-opaque');
        } else {
          nav.classList.remove('zr-scrolled', 'zr-opaque');
        }
      }

      window.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }
  }
})();
